import { ProductManagementContainer } from "../../Componant/organisms/ProductManagement";

type Props = {};

function ProductManagement({}: Props) {
  return (
    <div className="page-body">
      <ProductManagementContainer />
    </div>
  );
}

export default ProductManagement;
